import {
  BROKER_QUALITY_SCORECARD_LOANS_URL,
  DEFAULT_QUALITY_SCORECARD_WINDOW_DAYS,
} from './brokerQualityScorecardLoansApi.constants';

/**
 * File-quality scorecard client — Loans-gateway half (DEV-3777, Skynet.Loans).
 * GET /api/brokerQualityScorecardMetrics?windowDays=90 fills the broker-owned
 * time-in-status metric; the other four keys come back null-flagged (this
 * service does not own them) and are merged with the Underwriting half.
 *
 * The whole zone is dark until a backend feature toggle is on. When the toggle
 * is off the endpoint 404s — the caller treats that as "not available" and
 * hides the zone, so a 403 (broker-auth gap) AND a 404 (flag off) both pass
 * skipResponseInterceptor forbiddenError to avoid the global page-reload loop.
 *
 * Response shape (identical to the Underwriting half):
 *   { metrics, sampleSizes, programMixNote, windowDays, asOf, evaluatedAgainst,
 *     metricFlags }
 * where `metrics`/`sampleSizes` share the five keys: conditionsClearedWithinSlaPct,
 * submissionCompletenessPct, conditionClearTurnTimeMedianHours, firstTimeRightPct,
 * brokerOwnedTimeInStatusMedianHours.
 */
export class BrokerQualityScorecardLoansApi {
  #http;

  constructor(http) {
    this.#http = http;
  }

  async getQualityScorecardMetrics({
    windowDays = DEFAULT_QUALITY_SCORECARD_WINDOW_DAYS,
    config = {},
  } = {}) {
    return this.#http.get(BROKER_QUALITY_SCORECARD_LOANS_URL, {
      ...config,
      params: { windowDays },
    });
  }
}
